// extracted by mini-css-extract-plugin
export default {"modalOverlay":"zD-z","modalContent":"AD-z","header":"BD-z","close":"CD-z"};